export const msPerSec = 1000;
export const msPerMinute = 60 * msPerSec;
export const msPerHour = 60 * msPerMinute;
export const msPerDay = 24 * msPerHour;
